import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import Dashboard from './pages/Dashboard'
import Upload from './pages/Upload'
import Standings from './pages/Standings'
import Stats from './pages/Stats'
import Account from './pages/Account'
import GameDetails from './pages/GameDetails'
import GamesList from './pages/GamesList'
import Competitors from './pages/Competitors'
import GroupPlay from './pages/GroupPlay'
import Playoffs from './pages/Playoffs'
import BracketPlay from './pages/BracketPlay'
import MatchupCallTracker from './pages/MatchupCallTracker'
import TeamMatchupMatrix from './pages/TeamMatchupMatrix'
import TeamPerformance from './pages/TeamPerformance'
import RssFeed from './pages/RssFeed'
import Admin from './pages/Admin'
import './App.css'

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/upload" element={<Upload />} />
          <Route path="/standings" element={<Standings />} />
          <Route path="/group-play" element={<GroupPlay />} />
          <Route path="/playoffs" element={<Playoffs />} />
          <Route path="/bracket-play" element={<BracketPlay />} />
          <Route path="/stats" element={<Stats />} />
          <Route path="/stats/:categorySlug" element={<Stats />} />
          <Route path="/competitors" element={<Competitors />} />
          <Route path="/matchup-calls" element={<MatchupCallTracker />} />
          <Route path="/team-matchup-matrix" element={<TeamMatchupMatrix />} />
          <Route path="/team-performance" element={<TeamPerformance />} />
          <Route path="/account" element={<Account />} />
          <Route path="/games" element={<GamesList />} />
          <Route path="/games/:id" element={<GameDetails />} />
          <Route path="/players/:userId/games" element={<GamesList />} />
          <Route path="/teams/:teamName/games" element={<GamesList />} />
          <Route path="/matchups/:teamA/:teamB/games" element={<GamesList />} />
          <Route path="/rss" element={<RssFeed />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </Layout>
    </Router>
  )
}

export default App

